import { Component, OnInit, Input, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';

import { IContextMenuItem } from '../../interfaces/icontext-menu-item.interface';

@Component({
    selector: 'app-context-menu',
    templateUrl: './context-menu.component.html',
    styleUrls: ['./context-menu.component.scss'],
    standalone: false
})
export class ContextMenuComponent implements OnInit {
    // Properties.
    // Input.
    @Input() contextMenuData: IContextMenuItem[];
    @Input() menuName: string = 'unnamed'; // Note:  this property is only used to facilitate troubleshooting components that have multiple context menus.

    // Other properties.
    private contextItem: any = null;
    private menuPositionX: string = '0px';
    private menuPositionY: string = '0px';

    private menusWithSubmenus: IContextMenuItem[] = null;
    //private currentlySelectedMenuWithSubmenus: IContextMenuItem = null; 

    @ViewChild('itemContextMenuTrigger', { read: MatMenuTrigger }) itemContextMenu: MatMenuTrigger;
    @ViewChildren(MatMenuTrigger, { read: MatMenuTrigger }) submenuTriggers: QueryList<MatMenuTrigger>;

    // Constructor.
    public constructor() { }

    // Life cycle methods.
    public ngOnInit(): void {
    }

    public ngAfterViewInit(): void {
        // Note:  this method call is when we can check to see if @ViewChild() declarations have been resolved.
    }

    // Getter method.
    public get ContextItem(): any {
        return this.contextItem;
    }

    // Define methods called by components using this component.
    public openMenuForItemAt(contextItem: any, menuPositionX: string, menuPositionY: string): void {
        this.contextItem = contextItem;
        this.menuPositionX = menuPositionX;
        this.menuPositionY = menuPositionY;

        if ((this.contextMenuData != null) && (this.itemContextMenu != null)) {
            for (let index: number = 0; index < this.contextMenuData.length; index++) {
                let menuItem: IContextMenuItem = this.contextMenuData[index];
                menuItem.ContextItem = this.contextItem;
            }

            this.itemContextMenu.openMenu();
        }            
    }

    // Begin methods called by my HTML code.
    public get HasMenuData(): boolean {
        return ((this.contextMenuData != null) && (typeof this.contextMenuData != 'string') && (this.contextMenuData.length > 0));   
    }
    public get MenuData(): IContextMenuItem[] {
        return this.contextMenuData;
    }
    public get MenuDataWithoutSubmenus(): IContextMenuItem[] {
        let menusWithSubmenus: IContextMenuItem[] = this.contextMenuData.filter(m => !m.HasSubmenus);
        return menusWithSubmenus;
    }
    public get ExistsAnyMenuWithoutSubmenus(): boolean {
        let menusWithoutSubmenus = this.MenuDataWithoutSubmenus;
        return ((menusWithoutSubmenus != null) && (menusWithoutSubmenus.length > 0));
    }
    public get MenuDataWithSubmenus(): IContextMenuItem[] {
        //let menusWithSubmenus: IContextMenuItem[] = this.contextMenuData.filter(m => m.HasSubmenus);
        if (this.menusWithSubmenus == null) {
            this.menusWithSubmenus = this.contextMenuData.filter(m => m.HasSubmenus);
        }
        return this.menusWithSubmenus;
    }
    public ExistsAnyMenuWithSubmenus(): boolean {
        let menusWithSubmenus = this.MenuDataWithSubmenus;
        return ((menusWithSubmenus != null) && (menusWithSubmenus.length > 0));
    }
    public ExistsMenuWithSubmenus(menuIndex: number): boolean {
        return ((this.MenuDataWithSubmenus != null) && (this.MenuDataWithSubmenus.length > menuIndex));
    }
    public MenuSubmenus(menuIndex: number): IContextMenuItem[] {
        let menuWithSubmenus = this.MenuDataWithSubmenus[menuIndex];
        return (menuWithSubmenus != null ? menuWithSubmenus.Submenus : []); 
    }
    // End methods called by my HTML code.

    // Note:  the following two getter methods can return zero because the parent component is responsible for positioning this component.
    public get ComponentContextMenuPositionX(): string {
        return this.menuPositionX;
    }
    public get ComponentContextMenuPositionY(): string {
        return this.menuPositionY;
    }
    // End methods called by my HTML code.

    // Handle control events.
    public menuItemClicked(menuData: IContextMenuItem, eventData: any): void {
        menuData.menuItemSelected(this.contextItem, eventData);
    }
    /*
    public menuWithSubmenusClicked(menuData: IContextMenuItem, eventData: any): void {
        // TO DO:  CODE THIS METHOD.
        this.currentlySelectedMenuWithSubmenus = menuData;
    }
    */
}
